import AccessibilityNewOutlinedIcon from "@mui/icons-material/AccessibilityNewOutlined";
import FaceOutlinedIcon from "@mui/icons-material/FaceOutlined";
import React from "react";
import { useTranslation } from "react-i18next";
import PiChipSelect, { PiChipSelectOption } from "../../../components/PiChipSelect";

const WHOLE_BODY = "whole_body";
const HEAD_ONLY = "head_only";

/**
 * How a speaker looks at their listener: with the whole body (`finalIK` false, the
 * default) or with the head only (`finalIK` true, the game's FinalIK head look-at).
 * Design: Design Studio `lookat-rework` ("Look" chip; naming for non-game-devs).
 */
export default function PiLookModeChipSelect(props: {
  /** The interaction's `finalIK` value; missing means whole body. */
  value: boolean | undefined;
  onChange: (finalIK: boolean) => void;
  disabled?: boolean;
  "aria-label"?: string;
  /** Size to the content (e.g. the conversation composer row). */
  fit?: boolean;
}) {
  const { t } = useTranslation();
  const options: PiChipSelectOption[] = [
    {
      id: WHOLE_BODY,
      label: String(t("look_mode.whole_body")),
      icon: <AccessibilityNewOutlinedIcon className="flex-none" sx={{ fontSize: 18 }} />,
    },
    {
      id: HEAD_ONLY,
      label: String(t("look_mode.head_only")),
      icon: <FaceOutlinedIcon className="flex-none" sx={{ fontSize: 18 }} />,
    },
  ];

  return (
    <PiChipSelect
      tone="setting"
      aria-label={props["aria-label"] ?? String(t("look_mode.label"))}
      value={props.value ? HEAD_ONLY : WHOLE_BODY}
      options={options}
      onChange={(id) => props.onChange(id === HEAD_ONLY)}
      placeholder={String(t("look_mode.whole_body"))}
      disabled={props.disabled}
      fit={props.fit}
    />
  );
}
